import { gql } from '@apollo/client';

export const LEAD_DETAILS_QUERY = gql`
  query LeadDetails($selldirectLeadToken: String!) {
    odProtosListingsServicesListwithcertaintyproduct {
      getSellDirectDetails(input: { sellDirectLeadToken: $selldirectLeadToken }) {
        lead {
          experiencePartner {
            name
            email
          }
          latestOffer {
            state
            headlinePriceCents
            listingEstimateCeilingCents
            listingEstimateFloorCents
            initialInspectionAt
            finalOfferViewedAt
            expirationInfo {
              date
            }
            underwriting {
              state
              finalizedFeeCostCents
              finalizedFeePercentage
              finalizedHeadlinePriceCents
              estimatedClosingCostsCents
              estimatedNetProceedsCents
              repairAddendumAdjustmentCents
            }
            enabledExperiments {
              experimentEnum
            }
          }
          latestVirtualAssessment {
            orva {
              state
            }
          }
          lastOfferReviewDetails {
            offerReviewAt
          }
          id
          sellerInputUuid
          address {
            timeZone
            unitNumber
            market
            street
            city
            state
            postalCode
          }
          customerV2 {
            firstName
            lastName
            primaryPhoneNumber {
              number {
                value
              }
              type
            }
            primaryEmail {
              address {
                value
              }
            }
            otherEmails {
              address {
                value
              }
            }
          }
        }
      }
    }
  }
`;
